<!--選擇檢查地點-->
<div class="page-container reserve-location-content">
  <!--title 標題-->
  <h2 class="page-title">請選擇檢查地點</h2>

  <!--card 地點按鈕-->
  <div class="reserve-card-content" [class.single-location]="locations?.length === 1">
    @for (location of locations; track location.orgNo) {
      <button
        mat-button
        (click)="chooseLocation(location.orgNo)"
        [class.active]="selectedLocation === location.orgNo"
      >
        <h3 class="reserve-location-title">{{ location.orgName }}</h3>
        <p class="reserve-location-address">{{ location.orgAddress }}</p>

        <!-- 診所名稱 -->
        <div class="reserve-location-traffic">
          <img
            width="16"
            height="16"
            src="assets/img/i-building.svg"
            alt="bus"
          />
          <p class="reserve-location-traffic">
            {{ location.clinicName ? '隸屬' + location.clinicName + '診所' : '－' }}
          </p>
        </div>

        <!-- 大眾交通-->
        <div class="reserve-location-traffic">
          <img width="16" height="16" ngSrc="assets/img/i-bus.svg" alt="bus" />
          <p class="reserve-location-traffic">
            {{ location.orgTransport ? '近' + location.orgTransport : '－' }}
          </p>
        </div>

        <!-- 停車場資訊-->
        <div class="reserve-location-traffic">
          <img width="16" height="16" ngSrc="assets/img/i-car.svg" alt="car" />
          <p class="reserve-location-traffic">
            {{ location.orgParking ? location.orgParking : '－' }}
          </p>
        </div>

        <!-- 最低門檻金額 -->
         @if (this.sharedStorageService.get('reserveType') !== '2') {
          <div class="reserve-location-traffic">
            <img width="16" height="16" src="assets/img/i-money.svg" alt="car" />
            <p class="reserve-location-traffic">
              {{ location.amountThreshold ? '健檢方案 ＄' + location.amountThreshold + '~' : '-' }}
            </p>
          </div>
        }
      </button>
    }
  </div>
</div>
